import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import * as moment from 'moment';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { CalendarModule } from 'primeng/calendar';
import { PrimeNGConfig } from 'primeng/api';


@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  // standalone: true,
  // imports: [CalendarModule, FormsModule]
})

export class DateInputComponent {
  @Input() dateValue!: string;
  @Input() placeholder: string = "DD / MM / YYYY";
  @Input() dateInputFormat: string = 'DD/MM/YYYY';
  @Input() today: boolean = false;
  @Output() dateValueEmitter = new EventEmitter<string>();

  dateParsed: Date | null = null; // <-- Este será usado con [(ngModel)]
  dateError = false;


  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MM-YYYY',
    // containerClass: 'theme-default',
    // showWeekNumbers: false,
    daysDisabled: [6, 0],
    minDate: new Date(),
    // datesDisabled: this.productBlockedDates,
    // adaptivePosition: true,
    // isAnimated: true,
  };
  // ...

  ngOnInit() {
    // Validar y parsear la fecha inicial si existe
    if (this.dateValue) {
      const parsedMoment = moment(this.dateValue, this.dateInputFormat, true);
      this.dateParsed = parsedMoment.isValid() ? parsedMoment.toDate() : null;
    }

    // Tu lógica extra (traducciones, rangos, días inválidos...)
  }

  ngOnChanges() {
    if (this.dateValue) {
      const parsedMoment = moment(this.dateValue, this.dateInputFormat, true);
      this.dateParsed = parsedMoment.isValid() ? parsedMoment.toDate() : null;
    }
  }

  dateValueEmit(event: Date) {
    const isoString = moment(event, "DD-MM-YYYY")
      .set({
        hour: moment().hour(),
        minute: moment().minute(),
        second: 0,
        millisecond: 0
      })
      .format("YYYY-MM-DDTHH:mm:ss.SSS");

    this.dateValueEmitter.emit(isoString);

  }

  @ViewChild('dp', { static: false }) bsDatepicker!: BsDatepickerDirective;

  focusInput() {
    if (this.bsDatepicker) {
      this.bsDatepicker.show();
    }
  }
}


// export class DateInputComponent {

//   @Input()
//   dateValue!: string;

//   @Input()
//   placeholder: string = "DD / MM / YYYY"

//   @Input()
//   dateInputFormat: string = 'DD/MM/YYYY'

//   @Output()
//   dateValueEmitter = new EventEmitter()

//   dateError = false;
//   dateValueParse = "";

//   date = moment().format()
//   minDate: Date = new Date();
//   maxDate: Date = new Date();
//   es: any;
//   invalidDates: Date[] = [];


//   // es: any = null;

//   // lang = this.es

//   constructor(private primengConfig: PrimeNGConfig) { }

//   isDayEnabled = (date: Date): boolean => {
//     const day = date.getDay();
//     return day !== 0 && day !== 6; // Bloquea sábados (6) y domingos (0)
//   };


//   ngOnInit() {

//     this.primengConfig.setTranslation({
//       firstDayOfWeek: 1,
//       dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
//       dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
//       dayNamesMin: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sád"],
//       monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
//       monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
//       today: "Hoy",
//       clear: "Limpiar",
//       dateFormat: "dd/mm/yy",
//       weekHeader: "Sm"
//     });

//     // this.es = {
//     //   firstDayOfWeek: 1,
//     //   dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
//     //   dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
//     //   dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
//     //   monthNames: [
//     //     "enero", "febrero", "marzo", "abril", "mayo", "junio",
//     //     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
//     //   ],
//     //   monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
//     //   today: "Hoy",
//     //   clear: "Limpiar"
//     // };

//     // this.lang = this.es
//     // Definir rango desde 1950 hasta 2100
//     this.minDate = new Date(1950, 0, 1); // 1 de enero de 1950
//     this.maxDate = new Date(2100, 11, 31); // 31 de diciembre de 2100

//     // Generar los sábados y domingos como fechas inválidas
//     this.invalidDates = this.getDisabledWeekends(this.minDate, this.maxDate);


//   }



//   // Función que genera una lista de sábados y domingos entre minDate y maxDate
//   getDisabledWeekends(startDate: Date, endDate: Date): Date[] {
//     let invalidDates: Date[] = [];
//     let currentDate = new Date(startDate);

//     while (currentDate <= endDate) {
//       let day = currentDate.getDay();
//       if (day === 0 || day === 6) { // 0 = Domingo, 6 = Sábado
//         invalidDates.push(new Date(currentDate)); // Agregar una copia de la fecha
//       }
//       currentDate.setDate(currentDate.getDate() + 1); // Avanzar un día
//     }

//     return invalidDates;
//   }

//   ngOnChanges() {
//     if (this.dateValue) {
//       this.dateValueParse = moment(this.dateValue, this.dateInputFormat ? this.dateInputFormat : "").format('DD/MM/YYYY')
//     }
//   }

//   dateValueEmit(event: string) {
//     let parsedDate = moment(event);
//     let isoString = parsedDate.toISOString();

//     this.dateValueEmitter.emit(isoString);
//   }

//   // @ViewChild('dateInput') dateInput!: ElementRef<HTMLInputElement>;
//   @ViewChild('dp', { static: false }) bsDatepicker!: BsDatepickerDirective;


//   focusInput() {
//     if (this.bsDatepicker) {
//       this.bsDatepicker.show();
//     }
//   }

// }
